module.exports = __webpack_public_path__ + "prod/1.2.3/img/Alipay.d4993a1e.png";